'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  background: ', ';\n  padding: 5px;\n'], ['\n  width: 100%;\n  background: ', ';\n  padding: 5px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 15px;\n  height: 15px;\n  line-height: 15px;\n  border-radius: 50%;\n  background: ', ';\n  color: white;\n  text-align: center;\n  font-size: 9px !important;\n  cursor: pointer;\n  color: ', ' !important;\n'], ['\n  width: 15px;\n  height: 15px;\n  line-height: 15px;\n  border-radius: 50%;\n  background: ', ';\n  color: white;\n  text-align: center;\n  font-size: 9px !important;\n  cursor: pointer;\n  color: ', ' !important;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject, _colors.black);

var Button = _styledComponents2.default.div(_templateObject2, function (_ref) {
  var close = _ref.close;
  return close ? _colors.red : _colors.green;
}, _colors.white);

var Bar = function Bar(_ref2) {
  var fullscreen = _ref2.fullscreen,
      onClick = _ref2.onClick;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Button, null, _react2.default.createElement(_Icon2.default, {
    icon: fullscreen ? 'shrink' : 'arrowsalt',
    onClick: onClick
  })));
};

Bar.propTypes = {
  fullscreen: _propTypes2.default.bool,
  onClick: _propTypes2.default.func
};
exports.default = Bar;